export default function differenceInDays (date1: Date, date2: Date): number {
  const conversionFromMilisecondsToDays = 24 * 1000 * 3600
  const differenceInMiliseconds = Math.abs(date1.getTime() - date2.getTime());
  return Math.floor(differenceInMiliseconds / conversionFromMilisecondsToDays);
}
